export default __webpack_public_path__ + "static/media/logo.d781eb3e.svg";